import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { NzTableModule } from 'ng-zorro-antd/table';
import { ProductionBatch, InspectionModel } from '../../../model';

@Component({
  selector: 'app-batch-data-table',
  standalone: true,
  imports: [NzTableModule],
  template: `
    <nz-table #dataTable [nzData]="tableRows()" nzSize="small" [nzShowPagination]="false" nzFrontPagination="false" [nzBordered]="true" [nzScroll]="{ y: '200px' }">
      <thead>
        <tr>
          <th>Scan #</th>
          <th>L*</th>
          <th>a*</th>
          <th>b*</th>
        </tr>
      </thead>
      <tbody>
        @for (row of dataTable.data; track row.scanNumber) {
          <tr>
            <td>{{ row.scanNumber }}</td>
            <td>{{ row.l }}</td>
            <td>{{ row.a }}</td>
            <td>{{ row.b }}</td>
          </tr>
        }
      </tbody>
    </nz-table>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        font-size: 12px;
      }
      :host ::ng-deep .ant-table-cell {
        padding: 4px 8px !important;
      }
    `,
  ],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchDataTableComponent {
  batch = input.required<ProductionBatch>();
  type = input<'measured' | 'predicted' | 'reference'>('measured');
  model = input<InspectionModel | null>(null);

  tableRows = computed(() => {
    const b = this.batch();
    const mode = this.type();
    if (!b?.scans) return [];

    return b.scans
      .filter((s) => {
        if (mode === 'measured') return !!s.median;
        if (mode === 'predicted') return !!s.predicted;
        return false;
      })
      .map((s) => {
        const lab = mode === 'measured' ? s.median! : s.predicted!;
        return {
          scanNumber: s.sequenceInBatch,
          l: lab.l.toFixed(2),
          a: lab.a.toFixed(2),
          b: lab.b.toFixed(2),
        };
      });
  });
}
